// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@rails/activestorage").start()

require("@hotwired/stimulus")
require("@hotwired/turbo-rails")

// Custom Setup
require("jquery-validation")
require("controllers")

import "bootstrap";
import '../stylesheets/application.scss';

global.$ = jQuery;   // ASK TRL somehow this makes $ work in script tags

// Supposedly this allows jquery to work, but where the fuck does it go?
// https://stackoverflow.com/a/8175979/912244
$.ajaxSetup({
  headers: {
    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
  }
});

import "@fortawesome/fontawesome-free/js/all";

require("@nathanvda/cocoon")

require("smart_engine") // brings in trix and custom_action_text
require("packs/src/_bootstrap_custom")
require("packs/src/_modal")
require("packs/src/_select")
require("packs/src/_sortable_custom_fields")
